import { render, staticRenderFns } from "./FeatureFlagModal.vue?vue&type=template&id=22ed8034"
import script from "./FeatureFlagModal.vue?vue&type=script&lang=js"
export * from "./FeatureFlagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports